import TopShell from '@platform/faculties/finfac/appearance/TopShell.vue';
import SideShell from '@platform/faculties/pc-reference/appearance/SideShell.vue';
export const shells = { top: TopShell, side: SideShell };
